import { CheckCircle, Copy } from "@phosphor-icons/react";
import { NormalText, TooltipStyled } from "../styles";
import { copyToClipboard } from "../utils";
import { toast } from "react-toastify";
import { Box } from "@mui/material";

export const CopyButton = ({
  iconColor = "#0F110C",
  iconSize = 14,
  tooltipText,
  textToCopy,
}) => {
  function handleCopy() {
    copyToClipboard(textToCopy);
    toast(
      <Box display="flex" alignItems="center" gap="8px">
        <CheckCircle size={16} color="#FAFAFA" weight="fill" />
        <NormalText color="#FAFAFA" size={14}>
          Copied to clipboard
        </NormalText>
      </Box>
    );
  }
  return (
    <TooltipStyled title={tooltipText}>
      <Copy
        color={iconColor}
        size={iconSize}
        onClick={handleCopy}
        weight="regular"
        style={{ cursor: "pointer" }}
      />
    </TooltipStyled>
  );
};
